export default __webpack_public_path__ + "static/media/SYVIDED_DISABLE.c3e6b736.png";